import { CampaignPreset } from "../../../api/campaignPresets/types";

// Maps a stored campaign preset back into builder form values.
// Only the persisted content is carried over (preset metadata such as
// `name` is intentionally left out), and groupIds is normalised to an array.
export function mapPresetToFormValues(
  preset: CampaignPreset
): Record<string, unknown> {
  const content = { ...(preset.content as Record<string, unknown>) };
  return {
    ...content,
    groupIds: Array.isArray(content.groupIds) ? content.groupIds : [],
  };
}
